import { createClient, SupabaseClient } from "@supabase/supabase-js";
import { IBackendClient } from "./contracts";
import { mockBackendClient } from "./providers/supabase.mock";

const supabaseUrl = import.meta.env.VITE_SUPABASE_URL;
const supabaseAnonKey = import.meta.env.VITE_SUPABASE_ANON_KEY;
const useMocks = import.meta.env.VITE_USE_MOCKS === "true";

class SupabaseBackendClient implements IBackendClient {
  supabase: SupabaseClient | null;

  constructor() {
    this.supabase =
      supabaseUrl && supabaseAnonKey ? createClient(supabaseUrl, supabaseAnonKey) : null;
  }

  isConnected(): boolean {
    return !!this.supabase;
  }

  async syncState(_state: any): Promise<void> {
    if (!this.supabase) return;
    console.log("[Supabase] Syncing state to cloud shadow...");
    // Implementation for Phase 1
  }
}

export const backendClient: IBackendClient = useMocks
  ? mockBackendClient
  : new SupabaseBackendClient();

// Backward compatibility (Deprecated)
export const supabase = backendClient.supabase;
export const isBackendConnected = backendClient.isConnected();
